import React, { useState } from "react";
import styles from "./FloatingContact.module.css";
import { Phone, MessageCircle, MapPin, X } from "lucide-react";
import { MessageCircleMore } from "lucide-react";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.wrapper}>
      {/* Buttons container */}
      <div className={`${styles.buttons} ${open ? styles.show : ""}`}>
        <a
          href="https://wa.me/919798610111"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.actionBtn}
        >
          <MessageCircle size={20} />
          <span>WhatsApp</span>
        </a>

        <a href="tel:+919798610111" className={styles.actionBtn}>
          <Phone size={20} />
          <span>Call Us</span>
        </a>

        <a
          href="https://bni-patna.in/patna-bni-brisk/en-IN/visitorregistration"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.actionBtn}
        >
          <MapPin size={20} />
          <span>Visit Us</span>
        </a>
      </div>

      {/* Floating Toggle Button */}
      <button className={styles.floatingBtn} onClick={() => setOpen(!open)}>
        {open ? <X size={26} /> : <MessageCircleMore size={26} />}
      </button>
    </div>
  );
}
